import MenuItemsData from "../../components/hotel/datamanagement/MenuItemsData";

export default function MenuItemsPage() {
  return <MenuItemsData />;
}

